export const MaxClsValueRenderer = ({ value, row }) => {
  const { in_discovery } = row._original;

  return (
    <span>
      {value} {in_discovery && value >= 0 ? '\u002A' : ''}
    </span>
  );
};
